import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Sendchat = ({
  size,
  type,
  theme,
  className,
  dataTestId = "sendchat-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.4404 0.84972C14.505 0.461774 15.5377 1.49441 15.1497 2.55898L10.8366 14.3949C10.4013 15.5892 8.70041 15.5549 8.31368 14.344L7.14344 10.6797C7.10359 10.5549 7.10138 10.4212 7.13709 10.2951L8.02907 7.14719C8.12945 6.79295 8.49799 6.58715 8.85223 6.68752C9.20648 6.7879 9.41228 7.15644 9.3119 7.51069L8.47468 10.4654L9.58381 13.9383L13.897 2.10246L2.06109 6.41561L5.72537 7.58585C6.0761 7.69787 6.26963 8.073 6.15761 8.42374C6.0456 8.77447 5.67047 8.968 5.31973 8.85599L1.65545 7.68575C0.444516 7.29902 0.410212 5.59811 1.60457 5.16287L13.4404 0.84972Z"
    />
  </SVGIcon>
);
